import React from 'react';

import CommonImage from '@/components/CommonImage';

const JourneyTable = () => {
	return (
		<div className="journey-configuration-container px-4 py-2">
			<div className="journey-configuration-table mt-3">
				<table className="table with-border">
					<thead>
						<tr>
							<th>SL(12)</th>
							<th>Journey start</th>
							<th>End</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td className="sl-column">44</td>
							<td className="journey-start-column">2025-11-14</td>
							<td className="journey-end-column">2025-11-14</td>
							<td className="action-column">
								<div className="option">
									<div className="dropdown">
										<button
											aria-expanded="false"
											className="btn btn-default dropdown-toggle"
											data-toggle="dropdown"
											id="menu1"
											type="button"
										>
											<CommonImage src="/icons/more_icon.svg" alt="more_icon" />
										</button>
										<ul
											aria-labelledby="menu1"
											className="dropdown-menu dropdown-menu-right shadow-lg"
											role="menu"
											x-placement="bottom-end"
										>
											<li className="px-4 pb-3 pt-3" role="presentation">
												<a
													className="font-weight-normal  text-black"
													href="/invoices/edit/10052"
													role="menuitem"
													tabIndex={-1}
												>
													Edit journey
												</a>
											</li>
										</ul>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default JourneyTable;
